<div class="padding bg-light-grey">
	<div class="flex center">
		<span class="flex center primary hover margin-right" [routerLink]="['/photographers']">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Photographers
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		Edit photographer
	</div>
</div>

@if (photographer) {
	<div class="padding">
		<div class="page-layout">
			<div class="flex column">
				@if (form) {
					<form [formGroup]="form" class="form">
						<div class="flex center full-width between margin-bottom">
							<h4 class="margin-bottom">Edit photographer</h4>
							<button type="button" (click)="onSave()">
								<i class="fa fa-save"></i>
								Save changes
							</button>
						</div>

						<div class="flex center">
							<div class="flex-1 flex column margin-right-small">
								<span class="bold margin-bottom-small">Name Surname</span>
								<mat-form-field appearance="outline">
									<input matInput readonly [value]="photographer.fullName" />
								</mat-form-field>
							</div>

							<div class="flex-1 flex column">
								<span class="bold margin-bottom-small">Hired until</span>
								<mat-form-field appearance="outline">
									<input matInput [matDatepicker]="picker" formControlName="hiredUntil" />
									<mat-hint>DD/MM/YYYY</mat-hint>
									<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
									<mat-datepicker #picker></mat-datepicker>
								</mat-form-field>
							</div>
						</div>

						<div class="flex margin-top">
							<div class="flex-1 flex column margin-right-small">
								<span class="bold margin-bottom-small">Status</span>
								<mat-form-field appearance="outline">
									<mat-select formControlName="statusId">
										@for (state of status.data; track state) {
											<mat-option [value]="state.id">{{ state.name }}</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
							<div class="flex-1 flex end margin-bottom-small">
								<mat-slide-toggle formControlName="automaticRenewal">Auto Renewal</mat-slide-toggle>
							</div>
						</div>

						<div class="flex column margin-top">
							<span class="bold margin-bottom-small">Costs</span>
							<div class="flex center border padding">
								<div class="flex-1">
									<div class="flex column">
										<span class="bold margin-bottom-small">Cost per shot (€)</span>

										<mat-form-field appearance="outline" class="margin-right-small">
											<input type="number" matInput formControlName="shotCost" />
										</mat-form-field>
									</div>
								</div>
								<div class="flex-1">
									<div class="flex column">
										<span class="bold margin-bottom-small">Max items</span>
										<mat-form-field appearance="outline" class="margin-right-small">
											<input type="number" matInput formControlName="maxItems" />
										</mat-form-field>
									</div>
								</div>
								<div class="flex-1">
									<div class="flex column">
										<span class="bold margin-bottom-small">Discount (€)</span>
										<mat-form-field appearance="outline" class="margin-right-small">
											<input type="number" matInput formControlName="discountThreshold" />
										</mat-form-field>
									</div>
								</div>
								<div class="flex-1">
									<div class="flex column">
										<span class="bold margin-bottom-small">Discount percentage (%)</span>
										<mat-form-field appearance="outline" class="margin-right-small">
											<input type="number" matInput formControlName="discountPercentage" />
										</mat-form-field>
									</div>
								</div>
							</div>
						</div>

						<div class="flex column margin-top">
							<span class="bold margin-bottom-small">Products</span>

							<div class="padding border">
								<div class="flex center">
									<mat-form-field appearance="outline" class="margin-right-small">
										<mat-label>Brand</mat-label>
										<mat-select (selectionChange)="onSelectBrand($event.value)">
											@for (brand of brands.data; track brand) {
												<mat-option [value]="brand">{{ brand.brandName }}</mat-option>
											}
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline" class="margin-right-small">
										<mat-label>Category</mat-label>
										<mat-select (selectionChange)="onSelectCategory($event.value)">
											@for (category of categories.data; track category) {
												<mat-option [value]="category">{{ category.name }}</mat-option>
											}
										</mat-select>
									</mat-form-field>

									<button disabled]="!brands.selected" (click)="addBrand()">
										<i class="fa-solid fa-add"></i>
										Add
									</button>
								</div>

								@if (photographer.brands.length) {
									<table class="margin-top">
										<tr>
											<th>Brand</th>
											<th>Categories</th>
											<th>Action</th>
										</tr>

										@for (b of photographer.brands; track b) {
											@if (!b.categories.length) {
												<tr>
													<td>{{ b.brandName }}</td>
													<td>All categories</td>
													<td>
														<span class="flex center hover red" (click)="removeBrand(b)">
															<i class="fa fa-trash margin-right-small"></i>
															Remove
														</span>
													</td>
												</tr>
											} @else {
												<tr>
													<td>{{ b.brandName }}</td>
													<td>
														@for (s of b.categories; track s; let last = $last) {
															{{ s.categoryName }}
															@if (!last) {
																,
															}
														}
													</td>
													<td>
														<span class="flex center hover red" (click)="removeBrand(b)">
															<i class="fa fa-trash margin-right-small"></i>
															Remove
														</span>
													</td>
												</tr>
											}
										}
									</table>
								} @else {
									<div class="margin-top bg-light-grey padding-large flex center column">
										<div class="flex column grey center">
											<i class="fa-solid fa-add big margin-bottom-smallest"></i>
											Add products
										</div>
									</div>
								}
							</div>
						</div>
					</form>
				}
			</div>
		</div>
	</div>
}
